"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFT = exports.TOKEN = void 0;
exports.TOKEN = {
    dip20: 'DIP20',
    xtc: 'XTC',
    wicp: 'WICP',
    ext: 'EXT',
    icp: 'ICP',
    rosetta: 'ROSETTA'
};
exports.NFT = {
    ext: 'EXT',
    icpunks: 'ICPUNKS',
    departuresLabs: 'DEPARTURELABS',
    erc721: 'ERC721',
    dip721: 'DIP721',
    c3: 'C3',
    nftOrigyn: 'NFTORIGYN'
};
exports.default = {
    TOKEN: exports.TOKEN, NFT: exports.NFT
};
